export const SET_NTF_STATUS = 'SET_NTF_STATUS';
export const SET_NTF_STATUS_SUCCESS = 'SET_NTF_STATUS_SUCCESS';
export const SET_NTF_STATUS_FAILED = 'SET_NTF_STATUS_FAILED';

export const GET_POST_COMMENT_WS = 'GET_POST_COMMENT_WS';
export const GET_POST_COMMENT_WS_SUCCESS = 'GET_POST_COMMENT_WS_SUCCESS';
export const GET_POST_COMMENT_WS_FAILED = 'GET_POST_COMMENT_WS_FAILED';

export const SET_EDITING_POST = 'SET_EDITING_POST';
export const CLEAR_EDITING_POST = 'CLEAR_EDITING_POST';
export const UPLOAD_POST_FILE = 'UPLOAD_POST_FILE';
export const UPLOAD_POST_FILE_SUCCESS = 'UPLOAD_POST_FILE_SUCCESS';
export const UPLOAD_POST_FILE_FAILED = 'UPLOAD_POST_FILE_FAILED';
export const CHANGE_UPLOAD_POST_FILE = 'CHANGE_UPLOAD_POST_FILE';

export const SET_CURRENT_REPOST = 'SET_CURRENT_REPOST';
export const CLEAR_CURRENT_REPOST = 'CLEAR_CURRENT_REPOST';

export const LIKE_POST = 'LIKE_POST';
export const LIKE_POST_SUCCESS = 'LIKE_POST_SUCCESS';
export const LIKE_POST_FAILED = 'LIKE_POST_FAILED';